import FormularioActa from '../../components/actas/FormularioActa';

const Actas = () => (
  <div>
    <div style={{ marginBottom: '16px' }}>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>Actas</h1>
      <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
        Generación de actas académicas
      </p>
    </div>
    <FormularioActa isActa />
  </div>
);

export default Actas;
